import { Pipe, PipeTransform, Inject } from '@angular/core';
import { Temporal } from '@js-temporal/polyfill';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { AppStartupService } from '@ridango/core';

@Pipe({ name: 'findDayName', pure: true })
export class FindDayNamePipe implements PipeTransform {
    private readonly dayNames = [
        'LOCAL_CALENDAR_MONDAY_ddd',
        'LOCAL_CALENDAR_TUESDAY_ddd',
        'LOCAL_CALENDAR_WEDNESDAY_ddd',
        'LOCAL_CALENDAR_THURSDAY_ddd',
        'LOCAL_CALENDAR_FRIDAY_ddd',
        'LOCAL_CALENDAR_SATURDAY_ddd',
        'LOCAL_CALENDAR_SUNDAY_ddd'
    ];

    constructor(
        private appStartupService: AppStartupService,
        @Inject('ENV') private env: any
    ) {}

    transform(
        time: string | number | Date | Temporal.Instant | Temporal.ZonedDateTime | null | undefined,
        opts?: { isEnding?: boolean }
    ): string {
        if (time == null) {
            return '';
        }

        const isEnding = !!opts?.isEnding;
        const transportDayEndPrevDate = !!this.env?.TRANSPORT_DAY_END_PREV_DAY;
        const tz = this.appStartupService.getTimezone();

        let zdt = this.toZonedDateTime(time, tz);

        if (!zdt) {
            return '';
        }

        if (transportDayEndPrevDate && isEnding) {
            zdt = zdt.subtract({ days: 1 }).with({ hour: 23, minute: 59, second: 59, millisecond: 999 });
        }

        return this.dayNames[zdt.dayOfWeek - 1];
    }

    private toZonedDateTime(
        time: string | number | Date | Temporal.Instant | Temporal.ZonedDateTime,
        tz: string
    ): Temporal.ZonedDateTime | null {
        if (time instanceof Temporal.ZonedDateTime) {
            return time.withTimeZone(tz);
        }

        let instant: Temporal.Instant | null = null;

        if (time instanceof Temporal.Instant) {
            instant = time;
        } else if (typeof time === 'number') {
            instant = Temporal.Instant.fromEpochMilliseconds(time);
        } else if (time instanceof Date) {
            instant = Temporal.Instant.fromEpochMilliseconds(time.getTime());
        } else if (typeof time === 'string') {
            try {
                instant = Temporal.Instant.from(time);
            } catch (e) {
                try {
                    const plainDateTime = Temporal.PlainDateTime.from(time);
                    return Temporal.ZonedDateTime.from({
                        timeZone: tz,
                        ...plainDateTime.getISOFields()
                    });
                } catch (e2) {
                    const ms = Date.parse(time);
                    if (!isNaN(ms)) {
                        instant = Temporal.Instant.fromEpochMilliseconds(ms);
                    }
                }
            }
        } else {
            instant = Temporal.Now.instant();
        }

        if (instant) {
            return instant.toZonedDateTimeISO(tz);
        }

        console.warn(`[FindDayNamePipe] Invalid time string provided: "${time}". Returning empty string.`);
        return null;
    }
}
